"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        collapsed: {
            type: Boolean,
            default: undefined
        },
        collapsedSize: {
            type: String,
            default: undefined
        },
        collapsible: {
            type: Boolean,
            default: undefined
        },
        contentUrl: {
            type: String,
            default: undefined
        },
        max: {
            type: String,
            default: undefined
        },
        min: {
            type: String,
            default: undefined
        },
        resizable: {
            type: Boolean,
            default: undefined
        },
        scrollable: {
            type: Boolean,
            default: undefined
        },
        size: {
            type: String,
            default: undefined
        }
    }
};